export default __webpack_public_path__ + "static/media/안주3.421b6daa.png";